<template>
  <v-row
    v-if="appStoreUrl !== '' && playStoreUrl !== ''"
    class="ma-0"
    no-gutters
  >
    <v-col>
      <slot name="title">
        <h2 class="text-break homepageTitle">
          {{ $translate('DOWNLOAD_APP') }}
        </h2>
      </slot>

      <div class="text--darken-3 grey--text mt-1">{{ downloadText }}</div>

      <v-row class="my-4 mx-0" justify="center">
        <a
          v-if="currentOS === 'Android' || currentOS === 'unknown'"
          :href="playStoreUrl"
          class="mx-2 mx-md-6 max-button-width"
        >
          <v-img
            :src="require('@/assets/Download_on_the_Play_Store.png')"
            alt="Get it on Google Play"
          />
        </a>
        <a
          v-if="currentOS === 'iOS' || currentOS === 'unknown'"
          :href="appStoreUrl"
          class="mx-2 mx-md-6 max-button-width"
        >
          <v-img
            :src="require('@/assets/Download_on_the_App_Store.png')"
            alt="Download on the App Store"
          />
        </a>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import appDownloadMixin from '@/mixins/appDownload';

export default {
  name: 'AppDownloadButtons',
  mixins: [appDownloadMixin],
};
</script>

<style scoped lang="scss">
.max-button-width {
  max-width: 160px;
  display: inline-block;

  @media only screen and (max-width: 960px) {
    max-width: 140px;
  }
}
</style>
